var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGainWeight = function SvgGainWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2020",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0M3.646 4.646a.5.5 0 1 0 .708.708L5.5 4.207V9a.5.5 0 0 0 1 0V4.207l1.146 1.147a.5.5 0 1 0 .708-.708L6 2.293z"
  })));
};
export default SvgGainWeight;